import type { UpdateProductPayload } from '@/types/product';

/**
 * The fields PATCH /products/:id accepts (the API's UpdateProductDto). The API
 * refuses anything else with a 400, so the form fields that are not updatable
 * are dropped here: SKU (fixed at creation), unit, location and opening stock
 * (create-only), and description / expiry date (not stored yet).
 */
const UPDATABLE_FIELDS = [
  'name',
  'barcode',
  'category',
  'price',
  'price_adjustment',
  'cost',
  'gst_rate',
  'purchase_gst_rate',
  'tracking',
  'commission_pct',
  'hide_in_pos',
  'hide_in_sales',
  'hsn_code',
  'brand',
  'product_type',
  'low_stock_threshold',
  'is_active',
  'is_draft',
  'image_url',
] as const;

export function toProductUpdate(data: object): UpdateProductPayload {
  const src = data as Record<string, unknown>;
  const out: Record<string, unknown> = {};
  for (const key of UPDATABLE_FIELDS) {
    if (src[key] !== undefined) out[key] = src[key];
  }
  return out as UpdateProductPayload;
}
